import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const streamAccessTill = style([
  typography.labelSm,
  {
    height: 21,
    padding: `0 ${space.s10}px`,
    outline: `1px solid transparent`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: borderRadius.r64,
    outlineOffset: -1,
    transition: '.2s',
    whiteSpace: 'nowrap',
  },
  responsiveStyle({
    mobile: {
      width: '100%',
      background: 'transparent',
    },
    tablet: {},
    laptop: {
      backgroundColor: themeVars.container.tertiary.background.idle,
    },
  }),
]);
